var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            { attrs: { "drawer-button-disabled": _vm.drawerButtonDisabled } },
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.$ct(_vm.titleKey)) + " ")]
              ),
              _vm.product.ID != 0
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.remove()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "trash" } })],
                    1
                  )
                : _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "", disabled: _vm.lastLoadedDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.loadLastOpenedItem()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "clone" } })],
                    1
                  ),
              !_vm.isInfo
                ? _c(
                    "w-toolbar-item",
                    {
                      attrs: { white: "", disabled: _vm.isSaving },
                      on: {
                        click: function ($event) {
                          return _vm.save(true)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "save" } })],
                    1
                  )
                : _vm._e(),
              _c(
                "w-toolbar-item",
                {
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-wrap": "", "no-margin": "" } },
                    [
                      _c("w-tabs", {
                        attrs: { tabs: _vm.tabs },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      }),
                      !_vm.$wf.isSmDown && !_vm.isInfo
                        ? [
                            _c("w-spacer"),
                            _vm.buttonBarItems.length > 0
                              ? _c(
                                  "w-dropdown",
                                  {
                                    staticClass: "mr",
                                    attrs: {
                                      items: _vm.buttonBarItems,
                                      right: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.trigger($event)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "bars" } })],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "w-button",
                              {
                                attrs: {
                                  icon: "check",
                                  disabled: _vm.isSaving,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.save(true)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.save")) + " "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            {
              staticClass: "content",
              attrs: {
                tag: "div",
                "tag-attributes": { noMargin: true, noPadding: true },
              },
            },
            [
              _c(
                "transition",
                { attrs: { name: "fast-fade", mode: "out-in" } },
                [
                  _vm.currentTabKey == "general"
                    ? _c("app-tab-1", {
                        key: 1,
                        attrs: {
                          product: _vm.product,
                          "sku-disabled": _vm.skuDisabled,
                          "bar-code-exists": _vm.barCodeExists,
                        },
                        on: {
                          "verify-sku": _vm.checkIfSkuIsFree,
                          "check-barcode": _vm.checkIfBarCodeExists,
                        },
                      })
                    : _vm.currentTabKey == "buy"
                    ? _c("app-tab-2", {
                        key: 2,
                        attrs: { product: _vm.product },
                      })
                    : _vm.currentTabKey == "stock"
                    ? _c("app-tab-3", {
                        key: 3,
                        attrs: { product: _vm.product },
                      })
                    : _vm.currentTabKey == "extra-fields"
                    ? _c("app-tab-4", {
                        key: 4,
                        attrs: { product: _vm.product },
                      })
                    : _vm.currentTabKey == "taxes"
                    ? _c("app-tab-5", {
                        key: 5,
                        attrs: { product: _vm.product },
                      })
                    : _vm.currentTabKey == "documents"
                    ? _c("app-tab-6", {
                        key: 6,
                        attrs: { product: _vm.product },
                      })
                    : _vm.currentTabKey == "price-rules"
                    ? _c("app-tab-7", {
                        key: 7,
                        attrs: { product: _vm.product },
                      })
                    : _vm.currentTabKey == "label-settings"
                    ? _c("app-tab-8", {
                        key: 8,
                        attrs: { product: _vm.product },
                      })
                    : _vm.tab < _vm.extraFieldTabStart
                    ? _c("app-custom-view-tab-frames", {
                        attrs: {
                          "start-tab-index": _vm.defaultTabs.length,
                          tab: _vm.tab,
                          model: _vm.product,
                          tabs: _vm.customViewTabs,
                        },
                        on: {
                          "update-parent": function ($event) {
                            return _vm.onUpdateParent($event)
                          },
                        },
                      })
                    : _c("app-extra-field-tab", {
                        key: "extra-field-" + _vm.tab,
                        attrs: {
                          value: _vm.product.ExtraFields,
                          tab: _vm.extraFieldTabs[
                            _vm.tab - _vm.extraFieldTabStart
                          ],
                          "name-settings": _vm.extraFieldNamesConfig,
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }